export const gridLayoutV2 =
  ({ showReviewOrderPage }) =>
  ({ isMobile, isDesktop }) => ({
    width: "100%",
    height: "100%",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows:
      showReviewOrderPage && isMobile
        ? // review && isMobile
          // Header | Review | Footer
          "50px 1fr 30px"
        : isMobile
        ? // product && isMobile
          // Header | Product | Customisations | Footer
          "50px 1fr 100px 30px"
        : showReviewOrderPage
        ? // review && isDesktop/isTablet
          // Header | Review | Footer
          "70px 1fr 40px"
        : isDesktop
        ? // product && isDesktop
          // Header | Product | Customisations
          "70px 1fr 180px"
        : // product && isTablet
          // Header | Product | Customisations
          "70px 1fr 140px",
    zIndex: 40,
  });

export const productContainerV2 = {
  paddingTop: "20px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  position: "absolute",
  right: 0,
};

export const reviewOrderButtonContainer = {
  zIndex: 40,
};

export const reviewOrderButton = {
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.125)",
};
